document.addEventListener("DOMContentLoaded", () => {
  // Select all swiper containers inside .image-carousel
  const carousels = document.querySelectorAll(".profile-grid-carousel .swiper");

  carousels.forEach((carousel, index) => {
    // Initialize a new Swiper instance for each container
    new Swiper(carousel, {
      loop: false,
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 10,
      navigation: {
        nextEl: carousel.querySelector(".swiper-button-next"),
        prevEl: carousel.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: carousel.querySelector(".swiper-pagination"),
        clickable: true,
      },
      // Optional autoplay
      //autoplay: {
        //delay: 5000,
        //disableOnInteraction: false,
      //},
      autoplay: false, // Disable autoplay by default
      // Responsive breakpoints example
      breakpoints: {
        991: {
          slidesPerView: 4,
          slidesPerGroup: 2,
          spaceBetween: 20,
        },
        1199: {
          slidesPerView: 6,
          slidesPerGroup: 2,
          spaceBetween: 30,
        },
      },
    });
  });
});
